import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FCC } from '@zazume/zzm-base';
import React from 'react';

interface ContainerProps {
  center?: boolean;
  soft?: boolean;
}

const Container = styled.div<ContainerProps>(({ center, soft, theme }) => css`
  width: 100%;
  font-family: ${theme.fonts.base};
  font-size: ${theme.fontsSizes.sm};
  font-style: normal;
  font-weight: ${soft ? theme.fontWeights.semibold : theme.fontWeights.bold};
  line-height: ${theme.spacing.s12};
  letter-spacing: 0;
  color: ${theme.colors.Gray600};

  ${center && css`
    display: flex;
    align-items: center;
  `}
`);

type Headline3Props = ContainerProps
/**
 * @deprecated use zzm-base typography
 * @param props
 * @constructor
 */
export const Headline3: FCC<Headline3Props> = (props) => {
  return <Container {...props}>{props.children}</Container>;
};
